<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Galeria de Fotos - Álbum
  </app-header-dialog>

  <div *ngIf="entityForm">

    <div class="content">

      <div style="margin-top: 10px;">
        <input type="file" #fileImage (change)="onFileSelected($event)" accept="image/*, application/pdf"
          style="display:none;">
        <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
          style='background-color: whitesmoke;'>
          <mat-icon class='icon-add'>image_search</mat-icon>
          Selecionar imagem da capa
        </a>
        <span style="margin: 0 20px 0 40px;" *ngIf="selectedFileName">{{selectedFileName}}</span>
      </div>

      <div style="display: flex; justify-content: center; width: 100%; margin: 10px;">
        <img [src]="storedImage" style="width: 300px; height: 220px;" *ngIf="storedImage">
      </div>

      <div>
        <mat-form-field style='width: 190px;' appearance="outline">
          <mat-label>Data Entrada</mat-label>
          <input matInput [matDatepicker]="pickerIn" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.dateIn">
          <mat-datepicker-toggle matSuffix [for]="pickerIn"></mat-datepicker-toggle>
          <mat-datepicker #pickerIn></mat-datepicker>
        </mat-form-field>

        <mat-form-field style='width: 190px; margin-left: 20px;' appearance="outline">
          <mat-label>Data Saída</mat-label>
          <input matInput [matDatepicker]="pickerOut" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.dateOut">
          <mat-datepicker-toggle matSuffix [for]="pickerOut"></mat-datepicker-toggle>
          <mat-datepicker #pickerOut></mat-datepicker>
        </mat-form-field>

        <mat-form-field style='width: 190px; margin-left: 20px;' appearance="outline">
          <mat-label>Data Álbum</mat-label>
          <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

      </div>

      <mat-form-field style='width: 620px;' appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field style='width: 620px;' appearance="outline">
        <mat-label>Link</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.link"
          autocomplete="off">
      </mat-form-field>


      <mat-form-field style='width: 620px;' appearance="outline">
        <mat-label>Texto</mat-label>
        <textarea style="height: 200px;" matInput [errorStateMatcher]="matcher" [formControl]="entityForm.controls.text"
          autocomplete="off">
              </textarea>
      </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button
        (click)="matDialogRef.close(['update', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>